import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Gem, Award, Heart } from 'lucide-react';

const values = [
  { key: 'handmade', icon: Gem },
  { key: 'quality', icon: Award },
  { key: 'passion', icon: Heart },
];

export function ValueProposition() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 bg-secondary">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground mb-3">
            {t('values.title')}
          </h2>
          <div className="w-12 h-0.5 bg-bronze mx-auto rounded-full" />
        </motion.div>

        <div className="grid grid-cols-3 gap-4 md:gap-8">
          {values.map((value, index) => (
            <motion.div
              key={value.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center group"
            >
              <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-bronze/10 text-bronze mb-3 group-hover:bg-bronze group-hover:text-ivory transition-all duration-300">
                <value.icon className="w-5 h-5 md:w-6 md:h-6" />
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground mb-1">
                {t(`values.${value.key}.title`)}
              </h3>
              <p className="font-body text-xs md:text-sm text-muted-foreground leading-relaxed">
                {t(`values.${value.key}.description`)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
